<template>
  <div>
	  <div class="dingdan">
	  	<el-breadcrumb separator-class="el-icon-arrow-right">
	  	  <el-breadcrumb-item :to="{ path: '/demandHome/demandOrder'}">我的订单</el-breadcrumb-item>
	  	  <el-breadcrumb-item>查看评审</el-breadcrumb-item>
	  	</el-breadcrumb>
	  	<div class="fh_button" @click="fanhui" style="cursor:pointer;">
	  		<i class="el-icon-arrow-left"></i>
	  		<p>返回</p>
	  	</div>
	  </div>
	  <div class="PsTitle">
		  <div class="PsTaber">
			  <div @click="qiehuan(0)" :class="{'PsTaberClass':curNow==0}">承认图阶段 <span v-if="curNow==0"></span></div>
			  <div @click="qiehuan(1)" :class="{'PsTaberClass':curNow==1}">生产图阶段 <span v-if="curNow==1"></span></div>
		  </div>
		  <figure style="width:100%;text-align: center;padding-top:100px;" v-if="datails==''">
			  <img src="@/assets/kong.png" alt="" srcset="" />
			  <figcaption>暂无数据</figcaption>
		  </figure>
		  <div class="PsTaberbox" v-if="datails !=''">
			  <!-- 承认图 -->
			  <div>
				  <div class="PsCrf">
					<h4>评审概览</h4>
					<div class="PsCrf1">
					  <div class="PsCrf1_1">
						<img src="@/assets/fang2.png" alt="" srcset="" />
						<div>
							<p>支持需求方</p>
							<span style="font-weight:bold;color:#1E3A8A;">{{datails.support_demand_count || '0'}}人</span>
						</div>  
					  </div>
					  <div class="PsCrf1_1">
						<img src="@/assets/fang1.png" alt="" srcset="" />
						<div>
							<p>支持服务方</p>
							<span style="font-weight:bold;color:#FF5900;">{{datails.support_service_count || '0'}}人</span>
						</div>  
					  </div>
					  <div class="zanwu1" v-if="datails.win==0">最终结果：暂无结果</div>
					  <div class="zanwu2" v-if="datails.win==1">最终结果：需求方胜</div>
					  <div class="zanwu2" v-if="datails.win==2">最终结果：服务方胜</div>
					</div>  
				  </div>
				  <div class="PsContainer">
					 <div class="PsWrap1">
						 <div class="PsWrapTitle">
							<h4>需求方原因说明</h4> 
							<p>{{datails.pay_time*1000 | dateFormat}}</p>
						 </div>
						 <div class="PsSummary">
							 <h5>原因说明</h5>
							 <p>
								{{datails.demand_content}}
							  </p>
						 </div>
						 <div class="PsSummary" style="margin-top:20px;">
							 <h5>相关问题附件</h5>
							 <div>
								  <imglist :file="datails.demand_image" type='1'></imglist>
	<!-- 							 <img :src="i" alt="" srcset=""  v-for="(i,index) in datails.demand_image"/> -->
							 </div>
						 </div>
					 </div> 
					 <div class="PsWrap1">
						 <div class="PsWrapTitle">
							<h4>服务方原因说明</h4> 
							<p v-if="datails.defense_time>0">{{datails.defense_time*1000 | dateFormat}}</p>
							<p v-else-if="datails.defense_time==0 && leftColumnList.length==0" style="color: rgb(255, 89, 0);">辩护剩余时间： <CountDown :endTime="datails.defense_expire_time*1000"></CountDown> </p>
							<p v-else="leftColumnList.length>0 && datails.defense_time==0">超时未辩护</p>
						 </div>
						 <figure style="width:100%;text-align: center;padding-top:100px;" v-if="datails.defense_time==0">
							  <img src="@/assets/kong.png" alt="" srcset="" />
							  <figcaption>暂无数据</figcaption>
						 </figure>
						 <div class="PsSummary" v-if="datails.defense_time>0">
							 <h5>原因说明</h5>
							 <p>
								{{datails.service_content}}
							 </p>
						 </div>
						 <div class="PsSummary" style="margin-top:20px;" v-if="datails.defense_time>0">
							 <h5>相关问题附件</h5>
							 <div>
<!-- 								 <img :src="i" v-for="(i,index) in datails.service_image" alt="" srcset="" /> -->
								 <imglist :file="datails.service_image" type='1'></imglist>
							 </div>
						 </div>
						 <figure>
							 <!-- <img src="@" alt="" srcset="" /> -->
						 </figure>
					 </div>  
				  </div>
				  <div class="PsuserList" style="margin-bottom:50px;" v-if="(datails.reviewUsers || []).length>0">
					  <h4>评审人员详情</h4>
					  <div class="PsuserListdiv">
						 <div class="PsuserColumn">
							  <div v-for="(i,index) in leftColumnList" :key="'left-' + index" class="PsuserItem" v-if="i.user">
								  <img :src="i.user.avatar" alt="" class="PsuserAvatar" />
								  <div class="PsuserHeader">
									  <div class="PsuserName">
										 <p>{{i.user.nickname}}</p> 
										 <span  v-if="i.status==1 && i.support==2" style="background-color: #FFF5D9;color:#E7AA00;">支持服务方</span>
										 <span v-if="i.status==1 && i.support==1" style="background-color: #D9EAFF;color:#4297FF;">支持需求方</span>
										 <span v-if="i.status==-1" style="color:#FF5900;">到期未评审</span>
										 <span v-if="i.status==0 && i.expire_time==0" style="color:#FF5900;">待评审</span>
										 <div style="display:flex;" v-if="i.status==0 && i.expire_time>0">
										 	<span style="color:#FF0000;font-size: 24rpx;">待评审剩余时间：</span>
										 	<CountDown :endTime="i.expire_time*1000" color="#FF0000"/>
										 </div>
									  </div>
									  <div class="PsuserContent">
									  		<p v-if="i.content">{{i.content || "该评审人员未提交评审内容"}}</p>
									  		<span v-if="i.review_time>0">{{i.review_time*1000 | dateFormat}}</span>
									  		<figure v-if="!i.content ">
												 <img src="@/assets/kong.png" alt="" srcset="" />
												 <figcaption>暂无数据</figcaption>
									  		</figure>
									  </div>
								  </div>
							  </div>
						 </div>
						 <div class="PsuserColumn">
						  <div v-for="(i,index) in rightColumnList" :key="'right-' + index" class="PsuserItem" v-if="i.user">
							  <img :src="i.user.avatar" alt="" class="PsuserAvatar" />
							  <div class="PsuserHeader">
								  <div class="PsuserName">
								  	<p>{{i.user.nickname}}</p> 
									<span  v-if="i.status==1 && i.support==2" style="background-color: #FFF5D9;color:#E7AA00;">支持服务方</span>
									<span v-if="i.status==1 && i.support==1" style="background-color: #D9EAFF;color:#4297FF;">支持需求方</span>
									<span v-if="i.status==-1" style="color:#FF5900;">到期未评审</span>
									<span v-if="i.status==0 && i.expire_time==0" style="color:#FF5900;" >待评审</span>
									<div style="display:flex;" v-if="i.status==0 && i.expire_time>0">
										<span style="color:#FF0000;font-size: 24rpx;">待评审剩余时间：</span>
										<CountDown :endTime="i.expire_time*1000" color="#FF0000"/>
									</div>
								  </div>
								 <div class="PsuserContent">
								 		<p v-if="i.content">{{i.content || "该评审人员未提交评审内容"}}</p>
								 		<span v-if="i.review_time>0">{{i.review_time*1000 | dateFormat}}</span>
								 		<figure v-if="!i.content ">
											 <img src="@/assets/kong.png" alt="" srcset="" />
											 <figcaption>暂无数据</figcaption>
								 		</figure>
								 </div>
							  </div>
						  </div>
						 </div> 
					  </div>
				  </div>
			  </div>
		  </div>
	  </div>
  </div>
</template>

<script>
	import {
		OrderReviewDetail,
		detailByOrder
	} from "@/api/api.js"
	import CountDown from '@/common/CountDown.vue'
    import imglist from '@/common/imglist.vue'
	export default {
	  name: 'HelloWorld',
	  components:{
	  		CountDown,//倒计时
			imglist //查看附件下载
	  },
	  data() {
	    return {
		   curNow:0,
		   datails:"",
		   leftColumnList:"",
		   rightColumnList:""
	    }
	  },
	  computed: {
		// 将用户列表分成两列，实现瀑布流效果
		oid() {
		  return this.$route.query.oid || ''
		},
	  },
	  mounted() {
	     this.getdatails()
	  },
	  methods: {
		  fanhui(){
		  			 this.$router.go(-1);   
		  },
		getdatails(){
			let stage=""
			if(this.curNow==0){
				stage=1
			}else{
				stage=2
			}
			detailByOrder(this.oid,{
				stage:stage
			}).then(res=>{
				this.datails=res.data.data
				console.log(this.datails)
				if(this.datails.reviewUsers){
					this.leftColumnList=this.datails.reviewUsers.filter((item, index) => index % 2 === 0);
					this.rightColumnList=this.datails.reviewUsers.filter((item, index) => index % 2 === 1);
				}
			})
		},
		qiehuan(index){
			this.curNow=index
			this.getdatails()
		}
	  },
	}
</script>

<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.PsTitle{
		width:1200px;
		margin: 0 auto;
	}
	.PsTaber{
		width:100%;
		display:flex;
		justify-content:center;
	}
	.PsTaber>div{
		margin:0px 50px;
		cursor:pointer;
		font-weight: 400;
		font-size: 16px;
		padding-bottom:10px;
		color: #666666;
		position:relative;
	}
	.PsTaberClass{
		font-weight: bold !important;
		font-size: 16px !important;
		color: #1E3A8A !important;
	}
	.PsTaber span{
		display:inline-block;
		width: 24px;
		height: 3px;
		background: #1E3A8A;
		border-radius: 10px;
		position:absolute;
		bottom: 0;
		left: 50%;
		margin-left:-12px;
	}
	.PsTaberbox{
		width:100%;
		margin-top:16px;
	}
	.PsCrf{
		width:100%;
		height: 135px;
		background: #FFFFFF;
		border-radius: 12px;
		padding:20px;
		box-sizing: border-box;
	}
	.PsCrf1{
		display:flex;
		align-items: center;
		margin-top:15px;
	}
	.PsCrf>h4{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.PsCrf1_1{
		display:flex;
		align-items: center;
		margin-right:100px;
	}
	.PsCrf1_1 img{
		width:52px;
		height:52px;
		margin-right:10px;
	}
	.PsCrf1_1 div{
		text-align: center;
		font-weight: 400;
		font-size: 14px;
		color: #333333;
	}
	.zanwu1{
		width: 184px;
		height: 32px;
		background: rgba(204,204,204,0.7);
		border-radius: 15px;
		font-weight: 500;
		font-size: 16px;
		color: #FFFFFF;
		display:flex;
		justify-content:center;
		align-items:center;
	}
	.zanwu2{
		width: 200px;
		height: 32px;
		background: rgba(88,163,255,0.7);
		border-radius: 15px;
		font-weight: 500;
		font-size: 16px;
		color: #FFFFFF;
		display:flex;
		justify-content:center;
		align-items:center;
	}
	.PsContainer{
		width:100%;
		display:flex;
		justify-content:space-between;
		margin-top:16px;
	}
	.PsWrap1{
		width:588px;
		padding:20px;
		box-sizing: border-box;
		background-color:#fff;
		border-radius:8px;
	}
	.PsWrapTitle{
		width:100%;
		display:flex;
		align-items:center;
		justify-content:space-between;
	}
	.PsWrapTitle h4{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.PsWrapTitle span{
		font-weight: 400;
		font-size: 12px;
		color: #666666;
	}
	.PsSummary h5{
		line-height:60px;
		font-weight: bold;
		font-size: 14px;
		color: #333333;
		line-height:40px;
	}
	.PsSummary p{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
	}
	.PsSummary span{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
	}
	.PsSummary div{
		width:100%;
		display:flex;
		align-items: center;
	}
	.PsSummary img{
		width: 72px;
		height: 72px;
		border-radius:8px;
		margin-right:10px;
	}
	.PsuserList{
		width:100%;
		margin-top:16px;
		background-color:#fff;
		border-radius:12px;
		padding:20px;
		gap:16px;
		box-sizing: border-box;
	}
	.PsuserListdiv{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items:flex-start;
	}
	.PsuserList>h4{
		line-height:40px;
		font-weight: bold;
		font-size: 16px;
		color: #333333;
		margin-bottom:16px;
	}
	.PsuserColumn{
		width:572px;
		display:flex;
		flex-direction:column;
		gap:16px;
	}
	.PsuserItem{
		width:100%;
		background: #FFFFFF;
		border-radius: 12px;
		padding:12px;
		box-sizing: border-box;
		box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.05);
		transition: all 0.3s;
		display:flex;
	}
	.PsuserItem:hover{
		box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.1);
		transform: translateY(-2px);
	}
	.PsuserHeader>p{
		font-weight: 400;
		font-size: 14px;
		color: #1E3A8A;
	}
	.PsuserAvatar{
		width:40px;
		height:40px;
		border-radius:50%;
		border:1px solid #ccc;
		margin-right:12px;
		object-fit:cover;
	}
	.PsuserHeader{
		width: 494px;
	}
	.PsuserName{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.PsuserName p{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.PsuserName>span{
		display:inline-block;
		padding:2px 5px;
		box-sizing: border-box;
		font-weight: 500;
		font-size: 12px;
		border-radius:12px 0px 12px 0px;
	}
	.PsuserContent{
		width:100%;
	}
	.PsuserContent p{
		font-weight: 400;
		font-size: 12px;
		color: #333333;
		margin:0;
		word-break: break-word;
		text-align:justify;
	}
	.PsuserContent span{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		margin-top:15px;
	}
	.PsuserContent figure{
		width:100%;
		text-align: center;
		font-weight: 400;
		font-size: 14px;
		color: #666666;
	}
	.PsuserContent figure>img{
		width:60px;
		height:60px;
	}
</style>